var menuIsCollapsed;

function closeMenu() {
    if(!$('header').hasClass("collapsed")) {
        $('header').addClass("collapsed");
        $('.masthead__menuOverlay').fadeOut();
    }
	// enable body scrolling
	$("body").css('height','auto');
	$("body").css('overflow','auto');
}

function openMenu() {
    if($('header').hasClass("collapsed")) {
        $('header').removeClass("collapsed");
        $('.masthead__menuOverlay').fadeIn();
    }
	// disable body scrolling
	$("body").css('height','100vh');
	$("body").css('overflow','hidden');
}

function initMenu() {
    // INIT
    closeMenu();

    // ADD MENU TOGGLE BT TRIGGER
    $('.menuToggleBt').click(function(event){
		event.preventDefault();
        if($('header').hasClass("collapsed")) {
            openMenu();
        } else {
            closeMenu();
        }
    });

    // ADD MENU CLOSE BT TRIGGER
    $('.menuCloseBt').click(function(event){
		event.preventDefault();
        if($('header').hasClass("collapsed")) {
            openMenu();
        } else {
            closeMenu();
        }
    });

    // CLICK OUTSIDE
    $('.masthead__menuOverlay').click(function(event){
        event.preventDefault();
        if(!$('header').hasClass("collapsed")) {
            $('header').addClass("collapsed");
            $('.masthead__menuOverlay').fadeOut();
        }
    });
}

// ON PAGE READY
(function(w, d){
    //console.log("INIT MENU");
	initMenu();
}(window, document));